<!-- job-logs.component.html -->

<div class="jl">

  <!-- ── Page Header ─────────────────────────────── -->
  <div class="jl__header">
    <div>
      <h1 class="jl__title">Job Logs</h1>
      <p class="jl__subtitle">Track worker activity, GPS locations and submitted photos.</p>
    </div>
    <div class="jl__header-actions">
      <!-- Export -->
      <button class="jl__export-btn jl__export-btn--pdf" (click)="exportPdf()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <polyline points="14 2 14 8 20 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        PDF
      </button>
      <button class="jl__export-btn jl__export-btn--excel" (click)="exportExcel()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.8"/>
          <line x1="3" y1="9" x2="21" y2="9" stroke="currentColor" stroke-width="1.8"/>
          <line x1="3" y1="15" x2="21" y2="15" stroke="currentColor" stroke-width="1.8"/>
          <line x1="9" y1="3" x2="9" y2="21" stroke="currentColor" stroke-width="1.8"/>
        </svg>
        Excel
      </button>
      <a routerLink="/jobs" class="jl__back-btn">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M5 12L12 19M5 12L12 5"
                stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Back to Jobs
      </a>
    </div>
  </div>

  <!-- ── Summary Strip ───────────────────────────── -->
  <div class="jl__strip" *ngIf="!loading">
    <div class="jl__strip-item">
      <span class="jl__strip-val">{{ logs.length }}</span>
      <span class="jl__strip-label">Total Logs</span>
    </div>
    <div class="jl__strip-sep"></div>
    <div class="jl__strip-item">
      <span class="jl__strip-val">{{ totalHours }}</span>
      <span class="jl__strip-label">Hours Logged</span>
    </div>
    <div class="jl__strip-sep"></div>
    <div class="jl__strip-item">
      <span class="jl__strip-val">{{ uniqueWorkers }}</span>
      <span class="jl__strip-label">Workers</span>
    </div>
    <div class="jl__strip-sep"></div>
    <div class="jl__strip-item">
      <span class="jl__strip-val">{{ photoCount }}</span>
      <span class="jl__strip-label">Photos</span>
    </div>
  </div>

  <!-- ── Body Grid ────────────────────────────────── -->
  <div class="jl__body">

    <!-- ── Logs Panel ─────────────────────────────── -->
    <div class="jl__logs-panel">

      <div class="jl__panel-head">
        <h3 class="jl__panel-title">Activity Logs</h3>
        <span class="jl__panel-count" *ngIf="!loading">{{ logs.length }}</span>
      </div>

      <!-- Loading -->
      <div class="jl__loading" *ngIf="loading">
        <div class="jl__spinner"></div>
        <span>Loading logs…</span>
      </div>

      <!-- Empty -->
      <div class="jl__empty" *ngIf="!loading && logs.length === 0">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                stroke="currentColor" stroke-width="1.4"/>
          <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
          <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
        </svg>
        <p>No logs submitted yet for this job.</p>
      </div>

      <!-- Log list -->
      <div class="jl__log-list" *ngIf="!loading && logs.length > 0">
        <div class="jl__log-item" *ngFor="let log of pagedLogs">

          <!-- Avatar + Worker -->
          <div class="jl__log-worker">
            <div class="jl__log-avatar"
                 [style.background]="getAvatarColor(log.userId)">
              {{ getInitials(getWorkerName(log.userId)) }}
            </div>
            <div class="jl__log-meta">
              <span class="jl__log-name">{{ getWorkerName(log.userId) }}</span>
              <span class="jl__log-time">{{ log.createdUtc | date:'MMM d, h:mm a' }}</span>
            </div>
            <div class="jl__log-hours">
              <span class="jl__hours-val">{{ log.hoursSpent }}h</span>
            </div>
          </div>

          <!-- Notes -->
          <!-- <p class="jl__log-notes" *ngIf="log.notes">{{ log.notes }}</p>
          <p class="jl__log-notes jl__log-notes--empty" *ngIf="!log.notes">No notes submitted.</p> -->

                    <!-- Notes -->
<p class="jl__log-notes" *ngIf="log.workDone || log.notes">
    {{ log.workDone || log.notes }}
</p>
<p class="jl__log-notes jl__log-notes--empty" *ngIf="!log.workDone && !log.notes">
    No notes submitted.
</p>

          <!-- Photos -->
          <div class="jl__log-photos" *ngIf="log.photos?.length">
            <img
              class="jl__photo-thumb"
              *ngFor="let photo of log.photos"
              [src]="photo.url"
              alt="Log photo"
              (click)="openPhoto(photo.url)"
            />
          </div>

          <!-- Footer -->

<div class="jl__log-footer">
    <span class="jl__log-status"
          [class.jl__log-status--active]="getWorkerStatus(log.userId) === 'active'"
          [class.jl__log-status--offline]="getWorkerStatus(log.userId) === 'offline'">
        <span class="jl__log-status-dot"></span>
        {{ getWorkerStatus(log.userId) === 'active' ? 'Online' : 'Offline' }}
    </span>
    <button class="jl__focus-btn" (click)="focusLog(log)">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C8.1 2 5 5.1 5 9C5 14.2 12 22 12 22C12 22 19 14.2 19 9C19 5.1 15.9 2 12 2Z"
                  stroke="currentColor" stroke-width="1.8"/>
            <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="1.8"/>
        </svg>
        Focus on map
    </button>
</div>

        </div>
      </div>

      <!-- Pagination -->
      <div class="jl__pagination" *ngIf="totalLogPages > 1">
        <button class="jl__page-btn"
                (click)="logPage = logPage - 1; updatePagedLogs()"
                [disabled]="logPage === 1">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="jl__page-info">{{ logPage }} / {{ totalLogPages }}</span>
        <button class="jl__page-btn"
                (click)="logPage = logPage + 1; updatePagedLogs()"
                [disabled]="logPage === totalLogPages">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

    </div>

    <!-- ── Map Panel ──────────────────────────────── -->
    <div class="jl__map-panel">

      <div class="jl__panel-head">
        <h3 class="jl__panel-title">
          <span class="jl__live-dot"></span>
          GPS Tracking
        </h3>
        <!-- Playback controls -->
        <div class="jl__playback">
          <button class="jl__play-btn jl__play-btn--play"
                  (click)="startPlayback()"
                  [disabled]="isPlaying || logs.length === 0"
                  title="Play route">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <polygon points="5 3 19 12 5 21 5 3" fill="currentColor"/>
            </svg>
            Play
          </button>
          <button class="jl__play-btn jl__play-btn--stop"
                  (click)="stopPlayback()"
                  [disabled]="!isPlaying"
                  title="Stop playback">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" fill="currentColor"/>
            </svg>
            Stop
          </button>

          <!-- Playback progress -->
          <div class="jl__playback-progress" *ngIf="isPlaying">
            <div class="jl__playback-bar"
                 [style.width.%]="(playbackIndex / logs.length) * 100"></div>
          </div>
        </div>
      </div>

      <!-- Map -->
      <div id="logsMap" class="jl__map"></div>

    </div>

  </div>

</div>

<!-- ── Photo Lightbox ──────────────────────────────── -->
<div class="jl__lightbox" *ngIf="selectedPhotoUrl" (click)="closePhoto()">
  <div class="jl__lightbox-inner" (click)="$event.stopPropagation()">
    <button class="jl__lightbox-close" (click)="closePhoto()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
    <img class="jl__lightbox-img" [src]="selectedPhotoUrl" alt="Log photo"/>
  </div>
</div>